/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Sku_Code_TakenInputs */

const en_issue_sku_code_taken = /** @type {(inputs: Issue_Sku_Code_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`would get a SKU code another SKU already has`)
};

/**
* | output |
* | --- |
* | "would get a SKU code another SKU already has" |
*
* @param {Issue_Sku_Code_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_sku_code_taken = /** @type {((inputs?: Issue_Sku_Code_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Sku_Code_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_sku_code_taken(inputs)
});